import { useAuth0 } from "@auth0/auth0-react";
import LogoutIcon from "@mui/icons-material/Logout";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

import { clearAppLocalStorage } from "../../../utils/utils";

interface LogoutProps {
  isNavOpen: boolean;
}

export function Logout({ isNavOpen }: LogoutProps) {
  const { logout } = useAuth0();

  const button = (
    <IconButton
      onClick={() => {
        clearAppLocalStorage();
        logout();
      }}
      sx={{
        ":hover": {
          bgcolor: "#1E1D31",
          borderRadius: "12px",
          justifyContent: isNavOpen ? "left" : "center",
          padding: "8px 12px",
          width: isNavOpen ? "90%" : "100%",
        },
        fontSize: "0.875rem",
        borderRadius: "12px",
        justifyContent: isNavOpen ? "left" : "center",
        padding: "8px 12px",
        width: isNavOpen ? "90%" : "100%",
        color: "#F9FAFB",
      }}
    >
      <LogoutIcon
        sx={{ marginRight: isNavOpen ? ".75rem" : 0, width: 24, height: 24 }}
      />
      {isNavOpen && "Logout"}
    </IconButton>
  );

  return isNavOpen ? (
    button
  ) : (
    <Tooltip title="Logout" placement="right">
      {button}
    </Tooltip>
  );
}
